import { AsyncPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, ConfigModule } from '@spartacus/core';
import { PageSlotModule } from '@spartacus/storefront';
import { SdvorSharedCmsComponents } from '../cms-components.enum';
import { SlotComponent } from './slot.component';

@NgModule({
  imports: [
    AsyncPipe,
    PageSlotModule,
    ConfigModule.withConfig(<CmsConfig>{
      cmsComponents: {
        [SdvorSharedCmsComponents.RosaCMSSlotComponent]: {
          component: SlotComponent,
        },
      },
    }),
  ],
  declarations: [SlotComponent],
  exports: [SlotComponent],
})
export class SlotComponentModule {}
